<h1 mat-dialog-title>Selecionar Fase da Prova</h1>

<div mat-dialog-content>
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Fase</mat-label>
    <mat-select [(value)]="faseSelecionada">
      <mat-option [value]="ProvaFase.FASE1">Primeira Fase</mat-option>
      <mat-option [value]="ProvaFase.FASE2">Segunda Fase</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div mat-dialog-actions class="dialog-action">
  <button type="button" mat-button (click)="cancelar()">Cancelar</button>
  <button type="button" mat-raised-button color="primary" [disabled]="!faseSelecionada" (click)="confirmar()">Escolher</button>
</div>
